export class TechnicianModel {
  constructor() {
    this.contactId = 0;
    this.employeeId = "";
    this.firstName = "";
    this.lastName = "";
    this.isApproved = false;
    this.detail = "";
  }

  contactId: number;
  employeeId: string;
  firstName: string;
  lastName: string;
  isApproved?: boolean;
  detail?: string;
}
